export const staticDataLayer = {
  subsidiary_name: 'axa_partners',
  business_unit: 'assistance_and_services',
  digital_app_version: process.env.REACT_APP_DIGITAL_APP_VERSION,
};

export const synergyStaticDataLayer = {
  subsidiary_name: 'axa_partners',
  business_unit: 'customer_and_solutions',
  digital_business_process: 'assistance_request',
};
